import {Button} from "@mantine/core";
import "./PaymentPage.css";
import PaymentPageLogo from "../PaymentPageLogo/PaymentPageLogo";
import {useNavigate, useLocation} from "react-router";

const PaymentPage = ({textData, paymentImages}) => {
    const {title, subtitle, trackingCodeTxt, contentText, continueExploringButton, contactUsButton} = textData;
    const {paymentPageConfirmed, paymentFailedImage} = paymentImages;
    const location = useLocation();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search);
    const status = searchParams.get("status");
    const operationCode = searchParams.get("operation");
    const HandleButton = () => {
        navigate("/cursos");
    };
    const HandleButtonContact = () => {
        navigate("/contacto");
    }

    const imageToShow = status === "success" ? paymentPageConfirmed : paymentFailedImage;

    const renderContent = () => {
        if (status === "success") {
            return (
                <div className="paymentPage-father-div">
                    <div className="paymentPage-inscription-confirmed-div">
                        <div className="paymentPage-image-container-div">
                            <PaymentPageLogo imageUrl={imageToShow}/>
                        </div>
                        <div className="paymentPage-inscription-details-div">
                            <h3 className="paymentPage-confirmation-legend">
                                {title}
                            </h3>
                            <p className="paymentPage-description-legend">
                                {subtitle}
                            </p>
                            <div className="paymentPage-operation-div">
                                <p className="paymentPage-operation-code">{trackingCodeTxt} </p>
                                <hr className="paymentPage--line-separator"/>
                                <h3 className="paymentPage-operation-code-span">{operationCode}</h3>
                                <hr className="paymentPage--line-separator"/>
                            </div>
                            <p className="paymentPage-questions"> {contentText} </p>
                        </div>
                    </div>

                    <div className="paymentPage-button-div">
                        <Button fw="normal" onClick={HandleButton} color='var(--color-tertiary)'>
                            {continueExploringButton}
                        </Button>
                        <Button variant="outline" classNames={{root: 'paymentPage-firstButton-root'}} color='var(--color-text-primary)' fw="normal"
                                onClick={HandleButtonContact}>
                            {contactUsButton}
                        </Button>
                    </div>
                </div>
            );
        }

        // Si no es "success", asumir "cancel"
        return (
            <div className="paymentPage-father-div">
                <div className="paymentPage-inscription-confirmed-div">
                    <div className="paymentPage-image-container-div">
                        <PaymentPageLogo imageUrl={imageToShow} showSadImage={status !== "success"}/>
                    </div>
                    <div className="paymentPage-inscription-details-div">
                        <h3 className="paymentPage-confirmation-legend">
                            ¡Ups! Parece que algo salió mal con tu pago.
                        </h3>
                        <p className="paymentPage-description-legend">
                            ¡No te desanimes! ¡Tenemos otras formas de pago que puedes
                            aprovechar para no perderte esta oportunidad única!
                        </p>
                        <p className="paymentPage-questions"> Comunicate con el equipo de soporte para cualquier
                            información o inconveniente. </p>
                    </div>
                </div>

                <div className="paymentPage-button-div">
                    <Button classNames={{root: 'paymentPage-firstButton-root'}} fw="normal"
                        color="var(--color-tertiary)"
                            onClick={HandleButtonContact}>
                        Contáctanos
                    </Button>
                    <Button fw="normal" color='var(--color-text-primary)' onClick={HandleButton}>
                        Seguir explorando cursos
                    </Button>
                </div>
            </div>
        );
    };

    return <div className="paymentPage-father-div">{renderContent()}</div>;
};

export default PaymentPage;